{
  "version": 1,
  "asset_id": "c4f4a18d-689a-45a6-98e9-1c40d2b051aa",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/c4f4a18d-689a-45a6-98e9-1c40d2b051aa/lecanto-black-shingle-roof-480w.webp",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/c4f4a18d-689a-45a6-98e9-1c40d2b051aa/lecanto-black-shingle-roof-480w.webp",
  "original_filename": "lecanto-black-shingle-roof-480w.webp",
  "size": 51818,
  "content_type": "image/webp",
  "created_at": "2026-07-21T19:37:57Z"
}
